import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import chemicalbg from "../../assets/images/chemical-bg-01.jpeg";
import axios from "axios";
import { baseUrl } from "../../config/baseUrl";

export const EduHealthSafetyMgmt = () => {
  const navigate = useNavigate();
  let loginUser = JSON.parse(localStorage.getItem("user"));
  const [userType, setUserType] = useState(loginUser?.user_type);
  const [archivedVal, setArchivedVal] = useState("Archived");
  const [userCount, setUserCount] = useState(0);
  const [adminCount, setAdminCount] = useState(0);
  const [archivecount, setArchiveCount] = useState(0);
  const [forceUpdate, setForceUpdate] = useState(false);
  const [activateEduUserAdd, setActivateEduUserAdd] = useState(false);
  const [activateEduUserEdit, setActivateEduUserEdit] = useState(false);
  const [showList, setShowList] = useState(true);
  const [userData, setUserData] = useState({});

  // Accordion state
  const [sdsList, setSdsList] = useState([]);
  const [sdsLoading, setSdsLoading] = useState(true);
  const [sdsError, setSdsError] = useState("");

  const [docList, setDocList] = useState([]);
  const [docLoading, setDocLoading] = useState(true);
  const [docError, setDocError] = useState("");

  const [policyList, setPolicyList] = useState([]);
  const [policyLoading, setPolicyLoading] = useState(true);
  const [policyError, setPolicyError] = useState("");

  // Fetch SDS (chemicals)
  useEffect(() => {
    setSdsLoading(true);
    setSdsError("");
    axios
      .get(`${baseUrl}/get_college_subcategory/?per_page=10&page=1`, {
        headers: { Authorization: "Token " + localStorage.getItem("token") },
      })
      .then((res) => {
        setSdsList(res.data?.data || []);
        setSdsLoading(false);
      })
      .catch(() => {
        setSdsError("Failed to fetch chemicals.");
        setSdsList([]);
        setSdsLoading(false);
      });
  }, []);

  // Fetch Health Safety Documents
  useEffect(() => {
    setDocLoading(true);
    setDocError("");
    axios
      .get(`${baseUrl}/get_college_health_document/`, {
        headers: { Authorization: "Token " + localStorage.getItem("token") },
      })
      .then((res) => {
        setDocList(res.data?.data || []);
        setDocLoading(false);
      })
      .catch(() => {
        setDocError("Failed to fetch health safety documents.");
        setDocList([]);
        setDocLoading(false);
      });
  }, []);

  // Fetch Health Safety Policies
  useEffect(() => {
    setPolicyLoading(true);
    setPolicyError("");
    axios
      .get(`${baseUrl}/get_college_health_policy/?per_page=10&page=1`, {
        headers: { Authorization: "Token " + localStorage.getItem("token") },
      })
      .then((res) => {
        setPolicyList(res.data?.data || []);
        setPolicyLoading(false);
      })
      .catch(() => {
        setPolicyError("Failed to fetch health safety policies.");
        setPolicyList([]);
        setPolicyLoading(false);
      });
  }, []);

  return (
    <section className="main-sec">
      <div className="row">
        <div className="col-lg-12">
          <div className="d-flex w-full flex-row align-items-center justify-content-between">
            <div>
              <div className="dashboard-title">
                <h4 className="dash-head">
                  <i className="fa fa-users me-2" />
                  Chemical SDS
                </h4>
              </div>
              <div className="custom-bredcump">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/"> Dashboard </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Chemical SDS
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            <div className="d-flex flex-row justify-content-center align-items-center gap-2">
              <Link className="blu-btn" to="health-safety-document-list">
                <i className="fa fa-plus me-2" />
                Health Safety Document List
              </Link>
              <Link className="blu-btn" to="health-safety-policy-list">
                <i className="fa fa-plus me-2" />
                Health Safety Policy List
              </Link>
              <Link className="blu-btn" to="edu-chemical-cds-list">
                <i className="fa fa-plus me-2" />
                Chemical SDS List
              </Link>
            </div>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="chemical-bnnr">
            <img src={chemicalbg} className="w-100 rounded mb-3" alt="" />
            <h4 className="text-center fz-20">
              Advanced Facility Care takes Health & Safety seriously and we have
              put measures in place to ensure that our staff are equip with the
              correct training and will carry out works in a safe manner at all
              times.
            </h4>
          </div>
        </div>
        {/* Three-column accordion layout */}
        <div className="col-lg-12 mb-4">
          <div className="row">
            {/* Chemical SDS */}
            <div className="col-lg-4 col-md-4 col-sm-12 mb-3">
              <div className="chemical-listing-card">
                <div className="accordion">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#college-chemical-sds"
                      >
                        Chemical SDS
                      </button>
                    </h2>
                    <div
                      id="college-chemical-sds"
                      className="accordion-collapse collapse"
                    >
                      <div className="chemical-listing-card-innr">
                        {sdsLoading ? (
                          <div>Loading...</div>
                        ) : sdsError ? (
                          <div className="text-danger">{sdsError}</div>
                        ) : (
                          <ul className="chemical-list">
                            {sdsList.length === 0 ? (
                              <li>No chemicals found.</li>
                            ) : (
                              sdsList.map((chem) => (
                                <li key={chem.id}>
                                  {chem.subcategory_document ? (
                                    <a
                                      href={chem.subcategory_document}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {chem.subcategory_name}
                                    </a>
                                  ) : (
                                    chem.subcategory_name
                                  )}
                                </li>
                              ))
                            )}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Health Safety Document */}
            <div className="col-lg-4 col-md-4 col-sm-12 mb-3">
              <div className="chemical-listing-card">
                <div className="accordion">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#college-health-doc"
                      >
                        Health Safety Document
                      </button>
                    </h2>
                    <div
                      id="college-health-doc"
                      className="accordion-collapse collapse"
                    >
                      <div className="chemical-listing-card-innr">
                        {docLoading ? (
                          <div>Loading...</div>
                        ) : docError ? (
                          <div className="text-danger">{docError}</div>
                        ) : (
                          <ul className="chemical-list">
                            {docList.length === 0 ? (
                              <li>No health safety documents found.</li>
                            ) : (
                              docList.map((doc) => (
                                <li key={doc.id}>
                                  {doc.helth_document ? (
                                    <a
                                      href={doc.helth_document}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {doc.name}
                                    </a>
                                  ) : (
                                    doc.name
                                  )}
                                </li>
                              ))
                            )}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Health Safety Policy */}
            <div className="col-lg-4 col-md-4 col-sm-12 mb-3">
              <div className="chemical-listing-card">
                <div className="accordion">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#college-health-policy"
                      >
                        Health Safety Policy
                      </button>
                    </h2>
                    <div
                      id="college-health-policy"
                      className="accordion-collapse collapse"
                    >
                      <div className="chemical-listing-card-innr">
                        {policyLoading ? (
                          <div>Loading...</div>
                        ) : policyError ? (
                          <div className="text-danger">{policyError}</div>
                        ) : (
                          <ul className="chemical-list">
                            {policyList.length === 0 ? (
                              <li>No health safety policies found.</li>
                            ) : (
                              policyList.map((policy) => (
                                <li key={policy.id}>
                                  {policy.policy_document ? (
                                    <a
                                      href={policy.policy_document}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {policy.policy}
                                    </a>
                                  ) : (
                                    policy.policy
                                  )}
                                </li>
                              ))
                            )}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
